import SongStatSummary from './SongStatSummary';

export default SongStatSummary;
